/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./TOS.vue?vue&type=template&id=07019086&scoped=true&"
import script from "./TOS.vue?vue&type=script&lang=js&"
export * from "./TOS.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07019086",
  null
  
)

export default component.exports